export class EventsPopoverController {
  constructor(parent, marker, info) {
    this._parent = parent;
    this._marker = marker;
    this._info = info;

    // Popover View
    this._popoverView = new swim.PopoverView()
      .width(200)
      .height(115)
      .borderRadius(5)
      .padding(10)
      .backgroundColor(swim.Color.parse("#071013").alpha(0.9))
      .backdropFilter("blur(2px)");
    this._popoverView.setSource(this._marker);
    this._popoverView.hidePopover();

    // Box
    this._placard = this._popoverView.append('article')
      .className('placard')
      .color(swim.Color.parse('#a0a0a0'));

    // Header
    this._header = this._placard.append('header');

    this._title = this._header.append('h2')
      .className('title');

    // List
    this._listwrap = this._placard.append('ul')
      .className('list-wrap')
      .color(swim.Color.black());

    this._li0 = this._listwrap.append('li');
    this._li0Text = this._li0.append('span');

    this._li1 = this._listwrap.append('li');
    this._li1Text = this._li1.append('span');

    this._li2 = this._listwrap.append('li');
    this._li2Text = this._li2.append('span');

    // Content
    this._content = this._placard.append('div')
      .className('content');

    this._description = this._content.append('p')
      .className('description');

    this._date = this._content.append('p')
      .className('date');

    this._time = this._content.append('p')
      .className('time');

    this.update(this._info);
  }

  get view() {
    return this._popoverView;
  }

  update(info) {
    this._info = info;
    const color = this._parent.color;

    const title = info.get('name').stringValue();
    this._title.text(`${title}`)
      .color(color);

    this._li0.backgroundColor(color);
    this._li0Text.text(`${info.get('rad').numberValue(0)} KM`);

    if(this._parent.density > 0) {
      this._li1.backgroundColor(color);
      this._li1Text.text(`${Math.round(this._parent.density * 100)}%`);

      this._li2.backgroundColor(color);
      this._li2Text.text(`${Math.round(this._parent.density * 1000)}`);
    } else {
      this._li1.backgroundColor(swim.Color.transparent());
      this._li1Text.text('');

      this._li2.backgroundColor(swim.Color.transparent());
      this._li2Text.text('');
    }

    const description = info.get('desc').stringValue();
    this._description.text(`${description}`);

    const date = info.get('date').stringValue();
    const time = info.get('time').stringValue();
    this._date.text(`${date}, ${time}`);

  }

}
